@if (hasInsights) {
  <div class="ai-insights" [class.ai-insights--sender]="isSender">

    <button class="ai-insights__header" (click)="toggle()" [disabled]="isPending">
      <span class="ai-insights__header-left">
        @if (isPending) {
          <i class="fa-light fa-circle-notch fa-spin ai-insights__icon"></i>
          <span class="ai-insights__label">Analisi in corso…</span>
        } @else {
          <i class="fa-light fa-sparkles ai-insights__icon"></i>
          <span class="ai-insights__label">Analisi AI</span>
        }
      </span>
      @if (!isPending) {
        <i class="fa-light ai-insights__chevron"
           [class.fa-chevron-down]="!expanded"
           [class.fa-chevron-up]="expanded"></i>
      }
    </button>

    @if (expanded) {
      <div class="ai-insights__body">

        @if (audioTranscriptionEnabled) {
          @if (aiInsights!.audioTranscription; as tr) {
            @if (tr.status === 'COMPLETE' && tr.result) {
              <p class="ai-insights__transcription">{{ tr.result }}</p>
            } @else if (tr.status === 'FAILED') {
              <div class="ai-insights__error">
                <i class="fa-light fa-triangle-exclamation"></i>
                <span>{{ tr.error || 'Trascrizione non disponibile' }}</span>
              </div>
            }
          }
        }

        @if (plateDetectionEnabled) {
          @if (aiInsights!.plateDetection; as pd) {
            @if (pd.status === 'COMPLETE') {
              @if (pd.result.length > 0) {
                <div class="ai-insights__plates">
                  @for (plate of pd.result; track plate) {
                    <button class="ai-insights__plate-tag" (click)="copyPlate(plate)">
                      <span>{{ plate }}</span>
                      <i class="fa-light"
                         [class.fa-copy]="copiedPlate !== plate"
                         [class.fa-check]="copiedPlate === plate"></i>
                    </button>
                  }
                </div>
              } @else {
                <span class="ai-insights__no-results">Nessuna targa rilevata</span>
              }
            } @else if (pd.status === 'FAILED') {
              <div class="ai-insights__error">
                <i class="fa-light fa-triangle-exclamation"></i>
                <span>{{ pd.error || 'Rilevamento targa non disponibile' }}</span>
              </div>
            }
          }
        }

      </div>
    }
  </div>
}
